import { datadogRum } from '@datadog/browser-rum';
import packageJson from '../../../package.json';
import { isTrackingEnabled } from './is-tracking-enabled';

export default function initDatadogRum() {
  if (!isTrackingEnabled() || !import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
    return;
  }

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'hum',
    env: import.meta.env.VITE_ENV_NAME,
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 50,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}
